module.exports = __webpack_public_path__ + "static/media/raster.fragment.c0bc9e64.glsl";